import { createFileRoute } from "@tanstack/react-router";
import SuicidalIdeationPage from "@/pages/SuicidalIdeationPage";
export const Route = createFileRoute(
  "/suicidal-ideation-treatment-coral-springs-fl",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Suicidal Ideation Treatment Coral Springs | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Rapid stabilization and relief from acute suicidal thoughts with IV Ketamine therapy at Neuro Wellness TMS Centers in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content:
            "Suicidal Ideation Treatment Coral Springs | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Rapid stabilization and relief from acute suicidal thoughts with IV Ketamine therapy at Neuro Wellness TMS Centers in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/suicidal-ideation-treatment-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/suicidal-ideation-treatment-coral-springs-fl",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SuicidalIdeationPage />;
}
